module.exports = __webpack_public_path__ + "img/1571531086.ffc05779.jpg";